export const FileUploadResourcesBS: FileUploadResourcesInterface = {
  title: "Upload datoteka",
  selectBranch: "Odaberite poslovnicu",
  selectBranchPlaceholder: "Odaberite poslovnicu...",
  uploadButton: "Upload",
  uploading: "Učitavanje...",
  noFiles: "Nema uploadanih datoteka za ovu poslovnicu.",
  fileName: "Naziv datoteke",
  fileSize: "Veličina",
  uploadDate: "Datum uploada",
  actions: "Akcije",
  deleteConfirm: "Da li ste sigurni da želite obrisati ovu datoteku?",
  deleteButton: "Obriši",
  downloadButton: "Preuzmi",
  uploadSuccess: "Datoteka uspješno uploadana.",
  uploadError: "Greška prilikom uploada datoteke.",
  deleteSuccess: "Datoteka uspješno obrisana.",
  deleteError: "Greška prilikom brisanja datoteke.",
  noBranches: "Nemate dodijeljenih poslovnica kao menadžer.",
  chooseFile: "Odaberite datoteku",
};

export const FileUploadResourcesEN: FileUploadResourcesInterface = {
  title: "File Upload",
  selectBranch: "Select branch",
  selectBranchPlaceholder: "Select a branch...",
  uploadButton: "Upload",
  uploading: "Uploading...",
  noFiles: "No files uploaded for this branch.",
  fileName: "File name",
  fileSize: "Size",
  uploadDate: "Upload date",
  actions: "Actions",
  deleteConfirm: "Are you sure you want to delete this file?",
  deleteButton: "Delete",
  downloadButton: "Download",
  uploadSuccess: "File uploaded successfully.",
  uploadError: "Error uploading file.",
  deleteSuccess: "File deleted successfully.",
  deleteError: "Error deleting file.",
  noBranches: "You are not assigned as a manager to any branch.",
  chooseFile: "Choose file",
};

export const FileUploadResourcesDE: FileUploadResourcesInterface = {
  title: "Datei hochladen",
  selectBranch: "Filiale auswählen",
  selectBranchPlaceholder: "Filiale auswählen...",
  uploadButton: "Hochladen",
  uploading: "Wird hochgeladen...",
  noFiles: "Keine Dateien für diese Filiale hochgeladen.",
  fileName: "Dateiname",
  fileSize: "Größe",
  uploadDate: "Hochladedatum",
  actions: "Aktionen",
  deleteConfirm: "Sind Sie sicher, dass Sie diese Datei löschen möchten?",
  deleteButton: "Löschen",
  downloadButton: "Herunterladen",
  uploadSuccess: "Datei erfolgreich hochgeladen.",
  uploadError: "Fehler beim Hochladen der Datei.",
  deleteSuccess: "Datei erfolgreich gelöscht.",
  deleteError: "Fehler beim Löschen der Datei.",
  noBranches: "Sie sind keiner Filiale als Manager zugeordnet.",
  chooseFile: "Datei auswählen",
};

export interface FileUploadResourcesInterface {
  title: string;
  selectBranch: string;
  selectBranchPlaceholder: string;
  uploadButton: string;
  uploading: string;
  noFiles: string;
  fileName: string;
  fileSize: string;
  uploadDate: string;
  actions: string;
  deleteConfirm: string;
  deleteButton: string;
  downloadButton: string;
  uploadSuccess: string;
  uploadError: string;
  deleteSuccess: string;
  deleteError: string;
  noBranches: string;
  chooseFile: string;
}
